import React from 'react';
import { Users, FileText, Calculator, Shield, TrendingUp, Leaf, TreePine, Sprout, Globe, Search } from 'lucide-react';

export const mockData = {
  howItWorks: [
    {
      title: 'Estudo de viabilidade',
      description: 'Análise técnica inicial para verificar a viabilidade do projeto na área pretendida',
      icon: <Search className="h-8 w-8 text-ecam-blue" />
    },
    {
      title: 'Mobilização',
      description: 'Identificação e cadastro das comunidades e produtores familiares interessados',
      icon: <Users className="h-8 w-8 text-ecam-blue" />
    },
    {
      title: 'Coleta de dados',
      description: 'Levantamento de campo com dados de produção, área e práticas',
      icon: <FileText className="h-8 w-8 text-ecam-blue" />
    },
    {
      title: 'Cálculo',
      description: 'Análise técnica e cálculo do carbono sequestrado seguindo PCSAF',
      icon: <Calculator className="h-8 w-8 text-ecam-blue" />
    },
    {
      title: 'Certificação',
      description: 'Verificação e certificação dos créditos com transparência total',
      icon: <Shield className="h-8 w-8 text-ecam-blue" />
    },
    { 
      title: 'Comercialização',
      description: 'Venda dos créditos e reinvestimento nas comunidades',
      icon: <TrendingUp className="h-8 w-8 text-ecam-blue" />
    }
  ],
  
  territories: [
    {
      name: 'Carbono Social na Cadeia do Cacau Cabruca',
      region: 'Bahia',
      state: 'BA',
      partner: 'Parceria com Dengo Chocolates',
      project: 'Projeto Créditos para Terra - Credits for Life',
      description: 'Preservando a mata atlântica, produtores familiares cultivam o cacau em sistemas Cabruca, mantendo a floresta viva e fortalecendo a biodiversidade.',
      families: '104+ famílias',
      carbon: '1.006.115 tCO₂e',
      image: 'https://carbonosocial.ecam.org.br/images/webp/IMG_2470.webp',
      placeholder: 'Foto: IMG_2470.jpg'
    },
    {
      name: 'Carbono Social Quilombola',
      region: 'Amapá',
      state: 'AP',
      partner: 'Parceria com CONAQ',
      project: 'Projeto Carbono Social Quilombola',
      description: 'Comunidades quilombolas do Amapá mantêm viva a floresta e suas tradições, cultivando agricultura sustentável - mantendo a cultura de pé.',
      families: '675 famílias',
      carbon: '589.857 tCO₂e',
      image: 'https://carbonosocial.ecam.org.br/images/webp/bruna-leite-Mn-oZXPblTA-unsplash.webp',
      placeholder: 'Foto: bruna-leite-Mn-oZXPblTA-unsplash.jpg'
    },
    {
      name: 'Carbono Social da Erva-Mate',
      region: 'Paraná',
      state: 'PR',
      partner: 'Parceria com FETRAF e EcoAraucária',
      project: 'Projeto Carbono Social da Erva-Mate',
      description: 'A erva-mate, símbolo da cultura do sul, ganha novo significado através de práticas regenerativas sustentáveis.',
      families: '304 famílias',
      carbon: '1.387.492 tCO₂e**',
      carbonNote: '** Potencial aproximado',
      image: 'https://carbonosocial.ecam.org.br/images/webp/cecilia-skaf-hJ6PXEW3eqk-unsplash.webp',
      placeholder: 'Foto: cecilia-skaf-hJ6PXEW3eqk-unsplash.jpg'
    },
    {
      name: 'Carbono Social da Agricultura Familiar',
      region: 'Pará e Acre',
      state: 'PA-AC',
      partner: 'Parceria com SEBRAE',
      project: 'Projeto Carbono Social da Agricultura Familiar',
      description: 'Nas margens dos rios amazônicos, famílias agricultoras produzem com responsabilidade, preservando a floresta.',
      families: '200+ famílias',
      carbon: '(em execução)',
      image: 'https://carbonosocial.ecam.org.br/images/webp/photo-1516026672322-bc52d61a55d5.webp',
      placeholder: 'foto: agricultura-amazonica.jpg'
    }
  ],
  
  impactNumbers: [
    {
      number: '+1000',
      label: 'Agricultores familiares participantes',
      icon: <Users className="h-12 w-12 text-ecam-yellow" />
    },
    {
      number: '3m',
      label: 'Toneladas de CO₂ de emissão evitada',
      icon: <Leaf className="h-12 w-12 text-ecam-yellow" />
    },
    {
      number: '4',
      label: 'Estados Brasileiros',
      icon: <Globe className="h-12 w-12 text-ecam-yellow" />
    },
    {
      number: '100%',
      label: 'Agricultura familiar',
      icon: <Sprout className="h-12 w-12 text-ecam-yellow" />
    },
    {
      number: '20',
      label: 'Anos de impacto',
      icon: <TreePine className="h-12 w-12 text-ecam-yellow" />
    }
  ],
  
  timeline: [
    {
      year: 'Hoje',
      description: 'Mais de 1000 agricultores familiares em 4 estados gerando créditos de carbono com impacto social',
      icon: <Sprout className="h-8 w-8 text-white" />
    },
    {
      year: '5 anos',
      description: 'Expansão para 10+ territórios, dobrando o número de famílias beneficiadas',
      icon: <TreePine className="h-8 w-8 text-white" />
    },
    {
      year: '10 anos',
      description: 'Consolidação como referência em créditos de carbono social no Brasil',
      icon: <Leaf className="h-8 w-8 text-white" />
    },
    {
      year: '20 anos',
      description: 'Legado permanente de florestas restauradas e comunidades fortalecidas',
      icon: <Globe className="h-8 w-8 text-white" />
    }
  ],
  
  partners: [
    {
      name: 'Dengo Chocolates',
      website: 'https://www.dengo.com.br',
      logo: 'https://carbonosocial.ecam.org.br/images/svg/Logo%20dengo%20amarela%20preta.svg',
      isImage: true
    },
    {
      name: 'CONAQ',
      website: 'http://conaq.org.br',
      logo: 'https://carbonosocial.ecam.org.br/images/svg/Logo%20-%20CONAQ%20copy.svg',
      isImage: true
    },
    {
      name: 'FETRAF',
      website: 'https://fetrafbrasil.org.br',
      logo: 'https://carbonosocial.ecam.org.br/images/svg/logo-fetraf.png',
      isImage: true
    },
    {
      name: 'EcoAraucária',
      website: null,
      logo: 'https://carbonosocial.ecam.org.br/images/svg/logo-ecoaraucaria.svg',
      isImage: true
    },
    {
      name: 'SEBRAE',
      website: 'https://www.sebrae.com.br',
      logo: 'https://carbonosocial.ecam.org.br/images/svg/logo_sebrae_02.svg',
      isImage: true
    }
  ],
  
  realization: [
    {
      name: 'Ecam',
      logo: 'https://carbonosocial.ecam.org.br/images/svg/Logo%20Ecam%20Horizontal.svg',
      website: 'https://ecam.org.br'
    },
    {
      name: 'ReSeed',
      logo: 'https://carbonosocial.ecam.org.br/images/svg/Reseed_logo_LogotypeTM.svg',
      website: 'https://reseed.farm'
    }
  ]
};